import api from '../../api/client';
import React, { useState, useEffect, useCallback } from "react";
import AccountingReports from "../../components/accounts/accountsReport";

const GeneralLedger = () => {
  return (
    <>
      <AccountingReports reportType="trial-balance" />
    </>
  );
};

export default GeneralLedger;
